import { render, staticRenderFns } from "./Cliente.vue?vue&type=template&id=19460c2a&scoped=true&"
import script from "./Cliente.vue?vue&type=script&lang=js&"
export * from "./Cliente.vue?vue&type=script&lang=js&"
import style0 from "./Cliente.vue?vue&type=style&index=0&id=19460c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19460c2a",
  null
  
)

export default component.exports